export default __webpack_public_path__ + "c0e907c18ca8305ae8ba3b0523f6b016.png";